import { CSSProperties, ForwardedRef, ReactNode, forwardRef, useRef } from 'react'

import { CircularProgress } from '@material-ui/core'
import Close from '@material-ui/icons/Close'

import { Container } from './styles'

let promptModalId = 0

interface PromptModalProps {
  icon: JSX.Element
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  onClose: () => void
  title?: string
  description?: string
  leftTitle?: string
  onLeft?: () => void
  leftButtonStyles?: CSSProperties
  rightButtonStyles?: CSSProperties
  buttonContainerStyles?: CSSProperties
  contentStyles?: CSSProperties
  rightTitle?: string | ReactNode
  onRight: () => void
  rightLoading?: boolean
  isAlert?: boolean
  children?: ReactNode
  disableLeft?: boolean
  disableRight?: boolean
  leftPrimary?: boolean
}

const PromptModal = ({
  icon,
  size = 'sm',
  onClose,
  title,
  description,
  onLeft,
  rightTitle = 'Avançar',
  onRight,
  isAlert = false,
  leftTitle = 'Cancelar',
  rightLoading = true,
  children,
  rightButtonStyles = {},
  leftButtonStyles = {},
  buttonContainerStyles = {},
  contentStyles = {},
  disableLeft = false,
  disableRight = false,
  className,
  leftPrimary = false
}: PromptModalProps, ref: ForwardedRef<HTMLDivElement>) => {
  const id = useRef<number | null>(null)
  if (id.current === null) id.current = promptModalId++
  const descriptionId = `prompt-modal-description-${id.current}`
  const titleId = `prompt-modal-title-${id.current}`
  return (
    <Container
      ref={ref}
      aria-describedby={description ? descriptionId : undefined}
      aria-labelledby={title ? titleId : undefined}
      aria-modal='true'
      className={className}
      role='dialog'
      size={size}
      tabIndex={-1}
    >
      <div className='top-content'>
        {icon && <div className={`icon ${isAlert ? 'alert' : ''}`}>{icon}</div>}
        <button aria-label='Fechar' className='close-modal-top-button' type='button' onClick={onClose}>
          <Close />
        </button>
      </div>

      {(title || description) && (
        <div className='title-header'>
          {title && <h1 id={titleId}>{title}</h1>}
          {description && <p id={descriptionId}>{description}</p>}
        </div>
      )}

      {children && (
        <div className='center-content' style={{ ...contentStyles }}>
          {children}
        </div>
      )}

      <div
        className='footer-buttons'
        style={{
          ...buttonContainerStyles
        }}
      >
        {leftTitle && (
          <button
            style={{
              ...leftButtonStyles
            }}
            disabled={disableLeft}
            onClick={onLeft ? onLeft : onClose}
            className={leftPrimary ? 'action-button-left' : ''}
          >
            {leftTitle}
          </button>
        )}
        <button
          style={{
            ...rightButtonStyles
          }}
          disabled={disableRight}
          onClick={onRight}
          className={`action-button ${isAlert ? 'alert' : ''}`}
        >
          {rightTitle}
          {rightLoading && <CircularProgress size={12} color='inherit' />}
        </button>
      </div>
    </Container>
  )
}

export default forwardRef(PromptModal)
